module.exports = __webpack_public_path__ + "static/media/17e-02_ST-2017-305x610cm-oleo-sobre-madera.0ac1b7ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17e/17e-02_ST-2017-305x610cm-oleo-sobre-madera.jpg
// module id = 215
// module chunks = 0